// Chain IDs for supported networks
export const CHAIN_ID_ETHEREUM = 1;
export const CHAIN_ID_SEPOLIA = 11155111;
export const CHAIN_ID_ZCHAIN = 9369;
export const CHAIN_ID_ZEPHYR = 1417429182;

// Zero address constant
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
